/**
 * @description
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @example
 * ``` ts
 * isObjectLike({});
 * // => true
 * isObjectLike([1, 2, 3]);
 * // => true
 * isObjectLike(() => ({}));
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns `true` if `value` is object-like, else `false`.
 *
 * @docsCategory preference/lang
 * @codeFilter is-object-like
 */
export const isObjectLike = (value) => {
  return value != null && typeof value == 'object';
};
